(function () {
  'use strict';
  var R = (window.AB && window.AB.routes) || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' };
  var fmt = (window.AB && window.AB.moneyFormat) || '${{amount}}';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withComma;
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  var drawer = function () { return document.querySelector('.cart-drawer'); };
  function openCart() { var d = drawer(); if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); } }
  function closeCart() { var d = drawer(); if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); } }

  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (x) { x.textContent = cart.item_count; });
    var box = document.getElementById('cart-items');
    if (box) {
      box.innerHTML = cart.items.length ? cart.items.map(function (it) {
        return '<div class="cart-item"><div><strong>' + esc(it.product_title) + '</strong><div class="muted">' + it.quantity + ' × ' + money(it.final_price) + '</div></div><button class="add-btn" data-remove="' + esc(it.key) + '" type="button">Remove</button></div>';
      }).join('') : '<p class="muted">Your bag is empty.</p>';
    }
    var t = document.getElementById('cart-total');
    if (t) t.textContent = money(cart.total_price);
  }
  function refreshCart() {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(variantId, qty, btn) {
    if (btn) { btn.disabled = true; }
    return fetch(R.cart_add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(openCart)
      .catch(function (e) { alert((e && (e.description || e.message)) || 'Could not add this item.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  function removeLine(key) {
    return fetch(R.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-add'), 1, add); return; }
    var rem = e.target.closest('[data-remove]');
    if (rem) { e.preventDefault(); removeLine(rem.getAttribute('data-remove')); return; }
    if (e.target.closest('[data-cart-open]')) { openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer')) { closeCart(); return; }
    if (e.target.closest('.menu-toggle')) { var n = document.querySelector('.nav'); if (n) n.classList.toggle('open'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // Product form (AJAX add to bag)
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      var q = form.querySelector('[name="quantity"]');
      addToCart(id.value, q ? +q.value || 1 : 1, form.querySelector('[data-add-form]'));
    });
    var sel = form.querySelector('[data-variant-select]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var price = document.querySelector('[data-price]'); if (price && o.dataset.price) price.textContent = o.dataset.price;
      var sku = document.querySelector('[data-sku]'); if (sku) sku.textContent = o.dataset.sku || '';
      var ok = o.dataset.available === 'true';
      var stock = document.querySelector('[data-stock]');
      if (stock) {
        if (!stock.dataset.note) { var sub0 = stock.querySelector('[data-stock-sub]'); stock.dataset.note = sub0 ? sub0.textContent : ''; }
        stock.classList.toggle('stock--out', !ok);
        stock.querySelector('[data-stock-label]').textContent = ok ? 'In stock' : 'Out of stock';
        stock.querySelector('[data-stock-sub]').textContent = ok ? (stock.dataset.note || '') : '';
      }
      var btn = form.querySelector('[data-add-form]'); if (btn) { btn.disabled = !ok; btn.textContent = ok ? 'Add to Bag' : 'Sold Out'; }
      var url = new URL(location.href); url.searchParams.set('variant', o.value); history.replaceState({}, '', url);
    });
  });

  // Product gallery: one image at a time, thumbnails + prev/next
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('#gallery-main-image');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.thumb-btn'));
    if (!main || !thumbs.length) return;
    var current = 0;
    function show(i) {
      current = (i + thumbs.length) % thumbs.length;
      main.src = thumbs[current].getAttribute('data-full');
      thumbs.forEach(function (b, j) { b.classList.toggle('active', j === current); });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    var prev = g.querySelector('.gallery-arrow.prev'), next = g.querySelector('.gallery-arrow.next');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  });

  // Track your order
  var tabs = document.querySelectorAll('[data-track-tab]');
  tabs.forEach(function (b) {
    b.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      var tracking = b.getAttribute('data-track-tab') === 'tracking';
      document.getElementById('order-fields').hidden = tracking;
      document.getElementById('tracking-fields').hidden = !tracking;
    });
  });
  var trackBtn = document.querySelector('.track-submit');
  if (trackBtn) trackBtn.addEventListener('click', function () {
    var card = document.querySelector('[data-track-card]');
    var out = document.querySelector('[data-track-result]');
    var trackingMode = !document.getElementById('tracking-fields').hidden;
    function say(msg) { if (out) { out.hidden = false; out.innerHTML = msg; } }
    if (trackingMode) {
      var num = (document.getElementById('track-number').value || '').trim();
      if (!num) return say('Please enter your tracking number.');
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
      return say('Opening carrier tracking for <strong>' + esc(num) + '</strong>…');
    }
    var order = (document.getElementById('track-order').value || '').trim();
    var contact = (document.getElementById('track-contact').value || '').trim();
    if (!order || !contact) return say('Please enter your order number and the email or phone number used at checkout.');
    var email = card ? card.getAttribute('data-email') : '';
    say('Use the <strong>View your order</strong> link in your order confirmation email for live status, or <a href="/account/login"><strong>sign in</strong></a>. Need help? Email <a href="mailto:' + esc(email) + '?subject=' + encodeURIComponent('Order ' + order) + '">' + esc(email) + '</a> with order ' + esc(order) + '.');
  });

  // Hero video: make sure muted autoplay starts on iOS / after tab switch
  document.querySelectorAll('.ab-video-bg').forEach(function (v) {
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  });
})();
